import * as React from 'react';

import useVisibility from 'components/shared/customHooks/useVisibility';
import CustomModal from 'components/shared/CustomModal';
import { portalDownloadsPath } from 'javascript/application/ts_routes';
import { InvestmentRiskAssessment } from 'javascript/models';

export default function notifications({ userId }) {
  const { isOpen, handleOpen, handleClose } = useVisibility(false);

  React.useEffect(() => {
    const interval = setInterval(() => checkForDownloads(), 60000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  async function checkForDownloads() {
    const { data } = await InvestmentRiskAssessment.where({
      ownable_type: 'User',
      ownable_id: userId,
      created_at: { gte: new Date(Date.now() - 60000).toISOString() },
    }).all();

    if (data.length > 0) {
      handleOpen();
    }
  }

  return (
    <CustomModal isOpen={isOpen} title="Download Ready" handleClose={handleClose}>
      <div className="modal__content">
        <p className="text-small mar-v-0">
          Your download is ready you can get if from the{' '}
          <a href={portalDownloadsPath()} className="link link--blue">
            downloads page
          </a>
          .
        </p>
      </div>
    </CustomModal>
  );
}
